import React from 'react'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import TextInput from 'components/form/input/TextInput';
import SelectInput from 'components/form/input/SelectInput';

import FazendaEntity from 'entity/Fazenda';

import PerfisAutorizados from '../PerfisAutorizados';

function FazendaFormInter(props) {
    return <FormContent sx={{ m: 1 }}>
        <FormRow>
            <SelectInput
                sx={{ flex: 0.5 }}
                name="status"
                label="Status"
                options={["ATIVO", "INATIVO"]}
            />
            <TextInput sx={{ flex: 2 }} name="nome" label="Nome da Fazenda" required />
        </FormRow>
        <FormRow>
            <PerfisAutorizados name="perfisAutorizados" label="Perfis Autorizados" />
        </FormRow>
    </FormContent>
}

export default function FazendaForm() {
    return (
        <DefaultEntityCrud
            EntityClass={FazendaEntity}
            title={"Fazenda"}
            routeForm="fazenda"
            backRoute="consulta-fazenda"
            formActions={{ novoForm: true, salvarForm: true, sairForm: true }}
        >
            {(props) => {
                return <FazendaFormInter {...props} />
            }}
        </DefaultEntityCrud>
    )
}
